import React, { useMemo, useCallback, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Button, Icon } from 'gd-design-library';
import styles from './SearchImagePreview.module.scss';

const cx = classNames.bind(styles);
const CN = 'images-preview';
const itemClassName = `${CN}__item`;
const imageClassName = `${CN}__image`;
const buttonClassName = `${CN}__button`;
const actionsClassName = `${CN}__actions`;

interface SearchImagePreviewProps {
  uploadedImage: File | null;
  setUploadedImage: React.Dispatch<React.SetStateAction<File | null>>;
}

export const SearchImagePreview: React.FC<SearchImagePreviewProps> = ({
  uploadedImage,
  setUploadedImage
}) => {
  const imageUrl = useMemo(() => (uploadedImage ? URL.createObjectURL(uploadedImage) : null), [ uploadedImage ]);

  useEffect(() => (): void => { if (imageUrl) URL.revokeObjectURL(imageUrl); }, [ imageUrl ]);

  const handleImageCancel = useCallback(() => {
    if (imageUrl) URL.revokeObjectURL(imageUrl);
    setUploadedImage(null);
  }, [ imageUrl, setUploadedImage ]);


  if (!uploadedImage || !imageUrl) return null;

  return (
    <div className={ cx(CN) }>
      <div className={ cx(itemClassName) }>
        <img
          src={ imageUrl }
          alt={ uploadedImage.name }
          className={ cx(imageClassName) }
          onError={ (e): void => { (e.target as HTMLImageElement).style.display = 'none'; } }
        />
        <div className={ cx(actionsClassName) }>
          <Button
            isIcon
            variant='primary'
            onClick={ handleImageCancel }
            className={ cx(buttonClassName) }
            aria-label='Remove image'
          >
            <Icon name='cross' width={ 8 } height={ 8 } />
          </Button>
        </div>
      </div>
    </div>
  );
};
